import { render, staticRenderFns } from "./DetalheOfertaGlobal.vue?vue&type=template&id=315d8762&scoped=true"
import script from "./DetalheOfertaGlobal.vue?vue&type=script&lang=js"
export * from "./DetalheOfertaGlobal.vue?vue&type=script&lang=js"
import style0 from "./DetalheOfertaGlobal.vue?vue&type=style&index=0&id=315d8762&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315d8762",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('315d8762')) {
      api.createRecord('315d8762', component.options)
    } else {
      api.reload('315d8762', component.options)
    }
    module.hot.accept("./DetalheOfertaGlobal.vue?vue&type=template&id=315d8762&scoped=true", function () {
      api.rerender('315d8762', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DetalheOfertaGlobal.vue"
export default component.exports